import { useQuery } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { getProfileIdPaymentStatusCacheKey } from './cacheKeys';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { getIntl } from '../../utils/intl';
import { useQueryErrorNotify } from '../useQueryCallbacks';

const intl = getIntl('useIsProfilePaid', {
    loadError: 'Could not load payment status',
});

export type UseIsProfilePaidArgs = {
    profileId: string;
};

export type UseIsProfilePaidResponse = {
    isPaid: boolean;
    isLoading: boolean;
};

export const useIsProfilePaid = ({ profileId }: UseIsProfilePaidArgs): UseIsProfilePaidResponse => {
    const query = useQuery<APITypes.medicalProfileService.GetMedicalProfilePaymentStatusResponse>({
        queryKey: getProfileIdPaymentStatusCacheKey(profileId),
        queryFn: async (): Promise<APITypes.medicalProfileService.GetMedicalProfilePaymentStatusResponse> => {
            return appAPI.get<APITypes.medicalProfileService.GetMedicalProfilePaymentStatusResponse>(
                urls.api.paymentStatus.profilePaymentStatusById(profileId),
            );
        },
    });

    useQueryErrorNotify(query, intl('loadError'));

    return {
        isPaid: query.data ? query.data.isPaid : false,
        isLoading: query.isLoading,
    };
};
